/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type SearchAgentNotFoundErrorCode = (typeof SearchAgentNotFoundErrorCode)[keyof typeof SearchAgentNotFoundErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchAgentNotFoundErrorCode = {
  agent_not_found: "agent_not_found",
} as const;
